export const viewByKeys = ["Departments", "Locations"]

export const viewByOptions = viewByKeys.map((key) => ({
  label: key,
  value: key,
}))
